import { render, staticRenderFns } from "./GLogin.vue?vue&type=template&id=1a040fb6&scoped=true&"
import script from "./GLogin.vue?vue&type=script&lang=ts&"
export * from "./GLogin.vue?vue&type=script&lang=ts&"
import style0 from "./GLogin.vue?vue&type=style&index=0&id=1a040fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a040fb6",
  null
  
)

export default component.exports